/**
 * Dependency-free module that provides the resource tenant ID from localStorage.
 *
 * This module intentionally has zero imports from userProfileStore or axiosInstance,
 * serving as a bridge that breaks the circular dependency chain:
 *   userProfileStore → axiosInstance → resourceTenantProvider → (localStorage only)
 */

export const RESOURCE_TENANT_HEADER = 'X-Resource-Tenant-Id';

/**
 * Reads the resource tenant ID from localStorage.
 * Returns the tenant ID if the user has explicitly switched tenant via ClientSwitcher,
 * or null if no explicit switch has occurred (backend falls back to JWT claims).
 */
export function getResourceTenantId(): string | null {
  const value = localStorage.getItem('helios-current-tenant');
  return value || null;
}
